import { Card } from 'external/react'

import HomeItem from 'components/HomeItem'

const HomePage = () => {
	return (
            <Card.Body className='mt-2'>
               <div className="row mt-3 mb-3 justify-content-center">
                    <HomeItem className='mr-3' icon='faUsers' label='Clientes' to='/accounting/clients'>
                        <div className='text-muted mb-0'><span className='text-white'>.</span></div>
                    </HomeItem>
                    <HomeItem className='mr-3' icon='faDollar' label='Pagos' to='/accounting/payouts'>
                        <div className='text-muted mb-0'><span className='text-white'>.</span></div>
                    </HomeItem>
                </div>
            </Card.Body>
	)
}

export default HomePage